<section class="checkout-modal" [class.has-error]="!loading && loadError">
  @if (loading) {
  <div class="page-loading">
    <span>
      <span></span>
    </span>
  </div>
  } @if (!loading && !loadError) {
  <article>
    <button class="close" (click)="close()" style="margin-top: -15px">X</button>
    <checkout-summary
      [variant]="variant"
      [summary]="summary"
      [status]="status"
      [isDeliverable]="isDeliverable"
      (setPanel)="setPanel($event)"
      [activePanel]="activePanel"
    ></checkout-summary>
    <section class="purchase">
      <h1>{{ product.title }}</h1>
      @if (product.features.ticket) {
      <checkout-option
        [activePanel]="activePanel"
        [variant]="variant"
        [product]="product"
        [setOptions]="setOptions"
        [close]="close"
        [status]="status"
      ></checkout-option>
      } @if (product.features.product) {
      <checkout-products
        [activePanel]="activePanel"
        [variant]="variant"
        [product]="product"
        [setOptions]="setOptions"
        [close]="close"
        [status]="status"
      ></checkout-products>
      }
      <checkout-address
        [free]="isFree"
        [activePanel]="activePanel"
        [deliverable]="isDeliverable"
        title="billing"
        [setAddress]="setBillingAddress"
      ></checkout-address>
      <checkout-address
        [free]="isFree"
        [activePanel]="activePanel"
        [deliverable]="isDeliverable"
        title="shipping"
        [setAddress]="setShippingAddress"
      ></checkout-address>
      @if (!isFree) {
      <checkout-card [activePanel]="activePanel"></checkout-card>
      } @if (activePanel.getValue() == 'free-purchase') {
      <section class="free-purchase">
        <button class="button accordion-toggle" (click)="freePurchase()">
          Purchase
        </button>
      </section>
      }
    </section>
  </article>
  } @if (!loading && loadError) {
  <article class="checkout-error" aria-labelledby="checkout-error-title">
    <header class="checkout-error-header">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <h1 id="checkout-error-title">{{ loadErrorTitle }}</h1>
    </header>
    <div class="checkout-error-content">
      @if (checkoutItemTitle || product?.title) {
      <h2>{{ checkoutItemTitle || product.title }}</h2>
      }
      <p role="alert">{{ loadError }}</p>
      <div class="checkout-error-actions">
        @if (productUrl) {
        <a class="button" [href]="productUrl">Return to product</a>
        <a class="checkout-error-home" href="/">Return home</a>
        } @else {
        <a class="button" href="/">Return home</a>
        }
      </div>
    </div>
  </article>
  }
</section>
